import { PWMessage, PWMessageType } from "./PhysXWorker";

export class PhysXWorkerProxy {
  private worker: Worker;
  private receiver: any;
  constructor(receiver: any) {
    this.receiver = receiver;
    this.worker = new Worker(new URL('./PhysXWorker.ts', import.meta.url));
    this.worker.onmessage = (event) => {
      try {
        const type = event.data.type;
        if (!type) {
          console.error("Received message without type:", event.data);
          return;
        }
        if (receiver[type]) {
          receiver[type](event.data);
        }
      } catch (error) {
        console.error("Error in PhysXWorkerProxy onmessage handler:", error);
        // this.receiver.error({ type: PWMessageType.ERROR, error: `${error}` });
      }
    };
    this.postMessage({ type: PWMessageType.TEST });
  }

  postMessage<T extends PWMessage>(message: T) {
    // console.log("PhysXWorkerProxy postMessage:", message.type);
    this.worker.postMessage(message);
  }

  terminate() {
    this.worker.terminate();
  }
}